/*
 * RESPONSIVE POPUP LAYOUT
 *
 * Provides a shared primary-and-details composition for feature forms.
 *
 * Recent changes:
 * - Extracted the task popup grid so task and note dialogs share one responsive layout rule.
 */

import { ReactNode } from 'react';

interface ResponsivePopupLayoutProps {
  primary: ReactNode;
  details: ReactNode;
  stacked?: boolean;
  className?: string;
  testId?: string;
}

export default function ResponsivePopupLayout({
  primary,
  details,
  stacked = false,
  className = '',
  testId = 'responsive-popup-layout',
}: ResponsivePopupLayoutProps) {
  return (
    <div
      data-testid={testId}
      className={`${stacked ? 'grid-cols-1' : 'lg:grid-cols-[minmax(0,3fr)_minmax(19rem,2fr)]'} grid min-w-0 gap-6 lg:gap-8 ${className}`}
    >
      <div className="min-w-0 space-y-5">{primary}</div>
      <div className="min-w-0 space-y-5">{details}</div>
    </div>
  );
}

export type { ResponsivePopupLayoutProps };
